import o from "./ghl-ui.es1247.js";
import r from "./ghl-ui.es788.js";
function c(t) {
  return o(t, r(t));
}
export {
  c as default
};
